module.exports = __webpack_public_path__ + "media/assets/community/x-mark-blue-e5873ffcd33ab35fe9157778b25dfeff2f3de46b5a581d9faab9726aa2277e2e.png";